<template>
  <div class="model-tree">
    <div class="tree-node">
      <div class="model-key" :style="{ paddingLeft: `${indent}px` }">
        <i class="fold-icon" :class="foldIcon" v-if="model.type === 'object'" :style="{ left: `${indent - 24}px` }" @click="foldChildren"></i>
        <el-input v-model="field" placeholder="参数名称" :disabled="disableParam" @change="changParam" @blur="blurParam" :class="{ 'error-input': !field }"></el-input>
      </div>
      <el-tooltip effect="dark" :content="checkTip" placement="top">
        <el-checkbox v-model="checkState" :disabled="disableSelect"></el-checkbox>
      </el-tooltip>
      <el-select v-model="model.type" class="model-type" @change="changeType">
        <el-option v-for="index in types" :key="types[index]" :label="index" :value="index"> </el-option>
      </el-select>
      <el-input v-model="model.title" placeholder="标题" class="model-title" :class="{ 'error-input': param !== 'items' && !model.title }"></el-input>
      <el-input v-model="model.default" placeholder="默认值" class="model-default"></el-input>
      <el-input v-model="model.description" placeholder="备注" class="model-remark"></el-input>
      <div class="model-setting">
        <!-- <el-tooltip effect="dark" content="高级设置" placement="top">
          <i class="el-icon-setting"></i>
        </el-tooltip> -->
        <i class="el-icon-close" v-if="!isDisableItem" @click="delField"></i>
        <!-- 根节点添加按钮 -->
        <template v-if="isDisableItem">
          <el-tooltip effect="dark" content="添加子节点" placement="top" v-show="model.type === 'object'">
            <i class="el-icon-plus" @click="addField"></i>
          </el-tooltip>
        </template>
        <template v-else>
          <!-- 类型为对象的添加按钮 -->
          <el-tooltip effect="dark" content="添加兄弟/子节点" placement="top" v-show="model.type === 'object'">
            <div class="obj-add-wrap">
              <i slot="reference" class="el-icon-plus add-btn"></i>
              <div class="obj-add-btns">
                <div class="add-field-btn" @click="addSibling">兄弟节点</div>
                <div class="add-field-btn" @click="addField">子节点</div>
              </div>
            </div>
          </el-tooltip>
          <!-- 其他类型的添加按钮 -->
          <el-tooltip effect="dark" content="添加兄弟节点" placement="top" v-show="model.type !== 'object'">
            <i class="el-icon-plus" @click="addSibling"></i>
          </el-tooltip>
        </template>
      </div>
    </div>
    <div ref="treeRef">
      <model-tree v-if="model.items" :model="model.items" param="items" disableParam disableSelect :indent="indent + 20"></model-tree>
      <template v-if="model.properties">
        <model-tree
          v-for="key in keys"
          :key="key"
          :model="model.properties[key]"
          :param="key"
          :required="model.required"
          :indent="indent + 20"
          @addField="addField"
          @changeKey="changeKey"
          @delField="delChildField"
        ></model-tree>
      </template>
    </div>
  </div>
</template>
<script>
import { GetRandomField } from "@/utils/util";
export default {
  name: "model-tree",
  props: {
    model: Object,
    param: String,
    required: {
      default: () => [],
    },
    disableParam: Boolean,
    disableSelect: Boolean,
    indent: {
      default: 20,
    },
  },
  data() {
    return {
      keys: [],
      field: this.param,
      foldIcon: "el-icon-caret-bottom",
      checkTip: this.param == "root" ? "全选" : "是否必须",
      types: ["string", "number", "object", "array", "boolean"],
    };
  },
  mounted() {
    if (this.model.properties) this.keys = Object.keys(this.model.properties);
  },
  methods: {
    changParam(val) {
      if (val === "") return;
      if (this.$parent.checkSameKey(val)) {
        this.$emit("changeKey", this.param, val);
      } else {
        this.field = this.param; // 退回
      }
    },
    blurParam(val) {
      if (this.field === "") {
        this.$message.warning("参数名不能为空");
        this.field = this.param; // 退回;
      }
    },
    checkSameKey(newKey) {
      if (this.model.properties[newKey]) {
        this.$message.warning(`同层级字段${newKey}已经存在,不能相同`);
        return false;
      } else {
        return true;
      }
    },
    changeKey(key, newKey) {
      this.$set(this.model.properties, newKey, this.model.properties[key]);
      this.$delete(this.model.properties, key);
      this.admendReuqired(newKey, 1);
      this.admendReuqired(key, 0);
      // 替换key
      let index = this.keys.findIndex((k) => k === key);
      this.keys.splice(index, 1, newKey);
    },
    changeType(type) {
      if (type === "array") this.$set(this.model, "items", { type: "string" }); // array 类型默认添加items子元素
      if (type !== "Object") this.$delete(this.model, "properties"); // 非object类型，不显示properties子元素
      if (type !== "array" && this.model.items) this.$delete(this.model, "items"); // 非array类型，删除items
    },
    foldChildren() {
      if (this.$refs.treeRef.style.display === "") {
        this.$refs.treeRef.style.display = "none";
        this.foldIcon = "el-icon-caret-right";
      } else {
        this.$refs.treeRef.style.display = "";
        this.foldIcon = "el-icon-caret-bottom";
      }
    },
    addSibling() {
      this.$emit("addField");
    },
    addField() {
      const randomKey = GetRandomField("key_");
      if (this.model.properties) {
        this.$set(this.model.properties, randomKey, { type: "string" });
        this.keys.push(randomKey); // 新增key
      } else {
        this.$set(this.model, "properties", { [randomKey]: { type: "string" } });
        this.keys = [randomKey]; // 新增key
      }
      this.admendReuqired(randomKey, 1); // 新增的字段默认必填
    },
    delField() {
      this.$emit("delField", this.field);
    },
    delChildField(key) {
      this.$delete(this.model.properties, key);
      if (Object.keys(this.model.properties).length === 0) {
        this.$delete(this.model, "properties");
      }
      this.admendReuqired(key, 0);
      // 删除keys
      let index = this.keys.findIndex((k) => k === key);
      this.keys.splice(index, 1);
    },
    admendReuqired(key, type) {
      if (type) {
        // 新增
        if (this.model.required) this.model.required.push(key);
        else this.model.required = [key];
      } else {
        // 删除
        const index = this.model.required.findIndex((i) => i == key);
        this.model.required.splice(index, 1);
        if (this.model.required.length === 0) this.$delete(this.model, "required");
      }
    },
    changeAllRequired(obj, require) {
      if (obj.properties) {
        if (require) this.$set(obj, "required", Object.keys(obj.properties));
        else this.$delete(obj, "required");
        for (const key in obj.properties) {
          this.changeAllRequired(obj.properties[key], require);
        }
      }
    },
  },
  computed: {
    checkState: {
      get() {
        return this.required.findIndex((i) => i === this.field) > -1;
      },
      set(val) {
        if (this.field === "root") this.changeAllRequired(this.model, val);
        const index = this.required.findIndex((i) => i === this.field);
        if (index > -1) this.required.splice(index, 1);
        else this.required.push(this.field);
      },
    },
    isDisableItem() {
      return ["items", "root"].includes(this.field);
    },
  },
};
</script>
<style scoped lang="scss">
.model-tree {
  margin: 8px 0;
}

.tree-node {
  display: flex;
  align-items: center;

  .model-key {
    flex: 1;
    position: relative;
    margin-right: 10px;
    .fold-icon {
      position: absolute;
      top: 5px;
      font-size: 18px;
      padding: 2px;
      cursor: pointer;
      color: #999;
    }
  }
  .model-type {
    margin: 0 10px;
    flex: 0 0 10%;
    max-width: 10%;
  }
  .model-title {
    flex: 0 0 15%;
    max-width: 15%;
  }
  .error-input {
    ::v-deep {
      .el-input__inner {
        border: 1px solid #ff561b;
      }
    }
  }
  .model-default {
    margin-left: 10px;
    flex: 0 0 13%;
    max-width: 13%;
  }
  .model-remark {
    margin: 0 10px;
    flex: 0 0 18%;
    max-width: 18%;
  }
  .model-setting {
    flex: 0 0 86px;
    i {
      cursor: pointer;
      font-size: 18px;
    }
    .el-icon-setting {
      color: #00a854;
      margin-right: 4px;
    }
    .el-icon-close {
      color: #ff561b;
      margin-right: 4px;
    }
    .el-icon-plus {
      color: #2395f1;
      margin-right: 4px;
    }
  }
  .obj-add-wrap {
    position: relative;
    display: inline-block;
    &:hover {
      .obj-add-btns {
        display: inline-block;
      }
    }
    .obj-add-btns {
      display: none;
      position: absolute;
      top: 22px;
      left: 50%;
      width: 90px;
      background-color: #fff;
      box-shadow: 0 4px 15px #bbb;
      border-radius: 3px;
      transform: translate(-50%);
    }
    .add-field-btn {
      text-align: center;
      padding: 8px 10px;
      cursor: pointer;
      font-size: 14px;
      &:hover {
        background-color: #f4f4f4;
      }
    }
  }
}
</style>
